import { createContext, useContext, useState } from 'react';

const HeadingsContext = createContext({
  headings: [],
  setHeadings: () => {},
  activeId: '',
  setActiveId: () => {}
});

export function HeadingsProvider({ children }) {
  const [headings, setHeadings] = useState([]);
  const [activeId, setActiveId] = useState('');

  return (
    <HeadingsContext.Provider value={{ headings, setHeadings, activeId, setActiveId }}>
      {children}
    </HeadingsContext.Provider>
  );
}

export function useHeadings() {
  return useContext(HeadingsContext);
}



